import { getObserver } from "@util/Observer";
import { IExperimentAB } from "@util/experiment";

interface AdviceWindow extends Window {
    dataLayer: IMetadataObj[];
    experiment: IExperimentAB;
    google_tag_manager: any;
}

declare const window: AdviceWindow;

const GTM_CONTAINER_ID = "GTM-P3K3QB";

/**
 * Get the JSON from the element and parse it.
 */
 const getEventProps = (element: HTMLElement) => {
    const props = element.dataset.oskarProps;
    return props ? JSON.parse(props) : "";
};

/**
 * The function to fire for an Oskar View event.
 */
 const oskarViewTrigger = (element: HTMLElement) => {
    const event = element.dataset.oskarView || "";
    const eventProps = getEventProps(element);
    window.dataLayer.push({ event, ...eventProps });
};

/**
 * The function to fire for an Oskar click event.
 */
const oskarClickTrigger = (e: MouseEvent) => {
    const element = e.currentTarget as HTMLElement;
    const event = element.dataset.oskarClick || "";
    const eventProps = getEventProps(element);
    window.dataLayer.push({ event, ...eventProps });
};

const getExperimentData = () => {
    let experimentData = null;
    if (window.experiment) {
        experimentData = window.experiment.getOskarFormat();
    }
    if (!window?.google_tag_manager?.[GTM_CONTAINER_ID]) {
        window.dataLayer.push({ experiments: [experimentData] });
    } else {
        window.google_tag_manager[GTM_CONTAINER_ID].dataLayer.set("experiments", [experimentData]);
    }

    const oskarView = document.querySelectorAll("[data-oskar-view]");
    const oskarViewObserver = getObserver(oskarViewTrigger);
    oskarView.forEach(element => {
        oskarViewObserver.observe(element);
    });

    const oskarClickElements = document.querySelectorAll("[data-oskar-click]");
    oskarClickElements.forEach(element => {
        element.addEventListener("click", oskarClickTrigger);
    });
};

/**
 * Initialize the Oskar events.
 */
const initOskarTriggers = async () => {
    getExperimentData();
};

export { initOskarTriggers };
